import CommonTitleBar from "components/common/CommonTitleBar";
import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
// import WorkshopCard from "./WorkshopCard";
import NoDataFound from "components/common/NoDataFound";
import { useDispatch, useSelector } from "react-redux";
import { getAllWorkspaces } from "store/actions/workspaceSlice";
import Spinners from "components/common/Spinners";
import Paginations from "components/common/Paginations";
import RewardCard from "./RewardCard";
import { setPageTitle } from "components/common/Utils";
const Workshop = () => {
  const { t } = useTranslation();
  setPageTitle("Rewards" ,t);


  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { search } = useLocation();
  const pageNumber = Number(new URLSearchParams(search).get("page")) || 1;

  const {
    isLoading,
    loading,
    workspaces: workshops,
    drafts,
    perPage,
    totalCount,
    totalPages,
    currentPage,
  } = useSelector((state) => state.Workspace);

  useEffect(() => {
    getAllData();
  }, []);

  const getAllData = (page) => {
    const payload = {
      spaceTypeInt: 3, // Space Type Int [1-workSpace , 2-meetingRoom , 3-workShop]
      perPage: perPage,
      pageNo: page || pageNumber,
      status: -1,
      orderBy: -1,
      keyword: "",
      dateRange: {},
    };
    dispatch(getAllWorkspaces(payload));
    navigate(`/rewards/rewards?page=${page || pageNumber}`);
  };

  return (
    <React.Fragment>
      <div className="page-content common_page workshop_page">
        <Container fluid>
          <CommonTitleBar
            title={t("Rewards")}
            // isCreateBtn={true}
            // createBtnText={t("Add New")}
            // onCreateBtnClick={() => navigate("/management/branches/add-branch")}
          />
          <div className="common_wrapper">
            <RewardCard />
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Workshop;
